import { jsxs, jsx } from "react/jsx-runtime";
const IconEditSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M15.25.917c-1.167-1.167-3.333-1.167-4.5 0l-9.167 9.166c-.083.084-.166.25-.25.417L.5 14.667c-.083.25 0 .583.25.75.167.166.333.25.583.25H1.5l4.167-.834a.458.458 0 0 0 .416-.25l9.167-9.166a3.169 3.169 0 0 0 0-4.5ZM5.083 13.25l-2.666.5.5-2.667 7.166-7.166 2.167 2.166-7.167 7.167Zm9-9-.666.667L11.25 2.75l.667-.667c.583-.583 1.583-.583 2.166 0 .584.584.584 1.584 0 2.167Z" })
    ]
  }
);
export {
  IconEditSvg
};
